/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LizardUnitsEnum } from "./LizardUnitsEnum";
import {
  LizardUnitsEnumFromJSON,
  LizardUnitsEnumFromJSONTyped,
  LizardUnitsEnumToJSON,
  LizardUnitsEnumToJSONTyped,
} from "./LizardUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface LizardRasterRain
 */
export interface LizardRasterRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly uid?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  units?: LizardUnitsEnum;
  /**
   *
   */
  referenceUuid: string;
  /**
   *
   */
  startDatetime: Date;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  readonly interval?: number;
  /**
   *
   */
  readonly user?: string;
  /**
   *
   */
  readonly userId?: number;
  /**
   *
   */
  readonly originOffset?: number;
  /**
   *
   */
  readonly storePath?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the LizardRasterRain interface.
 */
export function instanceOfLizardRasterRain(value: object): value is LizardRasterRain {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (
    (!("referenceUuid" in (value as Record<string, any>)) &&
      !("reference_uuid" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["referenceUuid"] === undefined &&
      (value as Record<string, any>)["reference_uuid"] === undefined)
  )
    return false;
  if (
    (!("startDatetime" in (value as Record<string, any>)) &&
      !("start_datetime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startDatetime"] === undefined &&
      (value as Record<string, any>)["start_datetime"] === undefined)
  )
    return false;
  return true;
}

export function LizardRasterRainFromJSON(json: any): LizardRasterRain {
  return LizardRasterRainFromJSONTyped(json, false);
}

export function LizardRasterRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LizardRasterRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    uid: json["uid"] == null ? undefined : json["uid"],
    offset: json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    units: json["units"] == null ? undefined : LizardUnitsEnumFromJSON(json["units"]),
    referenceUuid: json["reference_uuid"],
    startDatetime:
      json["start_datetime"] == null
        ? json["start_datetime"]
        : parseDateTime(json["start_datetime"]),
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    interval: json["interval"] == null ? undefined : json["interval"],
    user: json["user"] == null ? undefined : json["user"],
    userId: json["user_id"] == null ? undefined : json["user_id"],
    originOffset: json["origin_offset"] == null ? undefined : json["origin_offset"],
    storePath: json["store_path"] == null ? undefined : json["store_path"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function LizardRasterRainToJSON(json: any): LizardRasterRain {
  return LizardRasterRainToJSONTyped(json, false);
}

export function LizardRasterRainToJSONTyped(
  value?: Omit<
    LizardRasterRain,
    | "url"
    | "uid"
    | "simulation"
    | "interval"
    | "user"
    | "userId"
    | "originOffset"
    | "storePath"
    | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    units: LizardUnitsEnumToJSON(value["units"]),
    reference_uuid: value["referenceUuid"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    multiplier: value["multiplier"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
